<div class="ga-ep__container">
  <div
    class="ga-ep__header"
    [ngClass]="{
      'ga-ep__header--clickable': trigger === 'all' && isCollapsible,
      'ga-ep__header--opened': opened
    }"
    (click)="toggleOpenState(false)"
  >
    <!-- Header content -->
    <ng-content select="[expansionHeader]"></ng-content>
    <div
      class="ga-ep__toggle"
      *ngIf="isCollapsible"
      [ngClass]="{ 'ga-ep__toggle--no-hover': trigger === 'all' }"
      (click)="toggleOpenState(true)"
    >
      <img *ngIf="opened" src="assets/icons/general/arrow-up.svg" class="ga-ep__toggle-icon" />
      <img *ngIf="!opened" src="assets/icons/general/arrow-down.svg" class="ga-ep__toggle-icon" />
    </div>
  </div>

  <div
    class="ga-ep__content"
    [ngClass]="{ 'ga-ep__content--show': opened }"
    [@expansionCollapseState]="opened || !isCollapsible ? 'shown' : 'hidden'"
  >
    <!-- Content -->
    <ng-content *ngIf="displayContent"></ng-content>
  </div>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/challenge-expansion-panel/challenge-expansion-panel.component.html